__turbopack_context__.v({
  "tooltipDark": "index-module___0ZExW__tooltipDark",
  "tooltipLight": "index-module___0ZExW__tooltipLight",
  "tooltipRoot": "index-module___0ZExW__tooltipRoot",
});
